import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

export interface EditCommentProps {
  onClick: () => void;
}

const EditComment: React.FC<EditCommentProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="EditComment">
      <button
        type="button"
        className="icon-before icon-writing"
        onClick={onClick}
      >
        {t('common:pages.forum.edit_comment.button')}
      </button>
    </div>
  );
};

export default EditComment;
